import React, { useState, useEffect } from 'react';
import { Image_Url } from '../../constants/imageUrl/ImageUrl';
import './resetpassword.scss'
import { resetPasswordAction } from '../../actions/passwordAction';
import { useDispatch } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import Loader from '../loaderComponent/Loader';
import { useNavigate } from 'react-router-dom';
import { HTTP_STATUS } from '../../constants/httpstatus/HttpsStatus';
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { useTranslation } from 'react-i18next';
import { allLanguageListAction } from '../../actions/loginAction';
import { fetchAndActivate, getValue, remoteConfig } from "../../configuration";

const ResetPasswordForm = () => {
  const [password, setPassword] = useState('');
  const [loading, setIsLoading] = useState(false)
  const [confirmPassword, setConfirmPassword] = useState('');
  const [language, setLanguage] = useState();
  const [errorMessage, setErrorMessage] = useState({
    password_error:"",
    confirmPassword_error:""
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const urlSearchParams = new URLSearchParams(window.location.search);
  const token = urlSearchParams.get('token');
  const languageid = urlSearchParams.get('lang');
  const countryHeader = urlSearchParams.get('country');
  const [isClickDisable, setIsClickDisable] = useState(false);
  const [countryData, setCountryData] = useState([]);
  const [isCountryDataSet, setIsCountryDataSet] = useState(false);
  const { i18n, t } = useTranslation();

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        await fetchAndActivate(remoteConfig);
        const configString = getValue(remoteConfig, process.env.REACT_APP_FIREBASE_DEV_KEY).asString();
        const parseConfig = JSON.parse(configString);
        setCountryData(parseConfig);
      } catch (error) {
        NotificationManager.error(error.message || 'There is an error in firebase');
      }
    };

    fetchConfig();
  }, []);

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  async function getlanguagelist() {
    try {
      setIsLoading(true)
      let response = await dispatch(allLanguageListAction());
      if (response === 200 || response != null) {
        setLanguage(
          response.data.data?.find((item) => item?.id === parseInt(languageid))
            ?.language.toLowerCase()
        );
      }
    } catch (error) {
      NotificationManager.error(error)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (countryHeader && countryData.length > 0) {
      localStorage.setItem('countryName', countryHeader);
      const matchedCountry = countryData.find(
        (item) => item.country.toLowerCase() === countryHeader.toLowerCase()
      );
  
      if (matchedCountry) {
        localStorage.setItem('countryBackendUrl', matchedCountry.backend_url);
        setIsCountryDataSet(true);
      }
    }
  }, [countryHeader, countryData]);
  
  useEffect(() => {
    if (isCountryDataSet) {
      getlanguagelist();
    }
  }, [isCountryDataSet]);

  useEffect(() => {
    if (language) {
      handleChangeLanguage(
        language === "english" ? "en" : "es"
      );
    }
  }, [language]);

  let validateForm = () => {
    let formIsValid = true;
    if (password === '') {
      formIsValid = false;
      setErrorMessage({ password_error: t('login.passwordError') });
    } else if (confirmPassword === '') {
      formIsValid = false;
      setErrorMessage({ confirmPassword_error: t('login.confirmpasserror') });
    }else if (password != confirmPassword){
      formIsValid = false;
      setErrorMessage({ confirmPassword_error: t('login.passwordmatcherror') });
    }
    else {
      setErrorMessage(" ");
    }
    return formIsValid;
  };

  const handleResetPassword = async () => {
    if (validateForm()) {
      setIsClickDisable(true)
      let apiReq = {
        token: token,
        new_password: password,
        verify_password: confirmPassword,
        language_id: languageid
      };
      let response = await dispatch(resetPasswordAction(apiReq));
      if (response?.status === HTTP_STATUS.SUCCESS ) {
        NotificationManager.success(response?.data?.message);
        navigate('/passwordconfirmation', { state: { key: 'reset_password' } });
        localStorage.clear();
        window.scroll(0, 0);
      }else if(response === undefined){
        setIsClickDisable(false);
      }
    }
  };

  const [isNewpasswordVisible, setNewpasswordVisible] = useState(false);
  const [isConfirmpasswordVisible, setConfirmpasswordVisible] = useState(false);

  const toggleNewpasswordVisibility = () => {
    setNewpasswordVisible(!isNewpasswordVisible);
  };
  const toggleConfirmpasswordVisibility = () => {
    setConfirmpasswordVisible(!isConfirmpasswordVisible);
  };

  return (
    <div className='reset-flex'>
      <div className='tvs-logo'>
        <img height='80px' width= '294px' src={Image_Url.TVSLOGO} alt='' />
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className="reset-password-form">
          <div>
            <label>{t('login.newpassword')}</label>
            <input
              type={isNewpasswordVisible ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <span
              className={`pass-icon ${isNewpasswordVisible ? 'visible' : ''}`}
              onClick={toggleNewpasswordVisibility}
            >
              {isNewpasswordVisible ? <FaEyeSlash /> : <FaEye />}
            </span>
            {errorMessage && <div className="error-message">{errorMessage.password_error}</div>}
          </div>

          <div>
            <label>{t('login.confirmnewpass')}</label>
            <input
              type={isConfirmpasswordVisible ? 'text' : 'password'}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <span
              className={`pass-icons ${isConfirmpasswordVisible ? 'visible' : ''}`}
              onClick={toggleConfirmpasswordVisibility}
            >
              {isConfirmpasswordVisible ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          {errorMessage && <div className="error-message">{errorMessage.confirmPassword_error}</div>}
          <button
            disabled={isClickDisable}
            onClick={handleResetPassword}>
            {t('login.resetpassword')}</button>
        </div>
      )}
    </div>
  );
};

export default ResetPasswordForm;
